import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const InfoToolTip = ({ languageCode, anchorId, classNameInfo, classNameTooltip, place }) => {
  return (
    <>
      <span
        className={`material-icons ${classNameInfo || ''}`}
        data-tooltip-id={anchorId}
        data-toggle="tooltip"
        data-html="true">
        info
      </span>
      <ReactTooltip
        className={`${classNameTooltip || ''}`}
        style={{ opacity: 1, zIndex: 99999 }}
        positionStrategy="fixed"
        id={anchorId}
        place={place || "bottom"}>
        <table className="tooltip-table">
          <tbody>
            <tr>
              <td>
                <div className="d-flex flex-column p-1">
                  <p className="statistics-tooltip-text mb-0">{languageCode}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ReactTooltip>
    </>
  );
};

export default InfoToolTip;
